import type { CoreBrand, CoreState } from '../../types'

export const findActiveBrand = (state: CoreState): CoreBrand | undefined => {
  return state.brands.find((brand) => brand.id === state.activeBrand)
}
